import React from 'react';
import { deliveryWhen } from '../../shared/format';
import { statusMod, orderAddressLine } from '../../shared/orderStatus';

// Компактная карточка текущего заказа — аналог CurrentOrder из клиентского
// приложения: номер, статус, адрес, дата и интервал. Без действий и позиций:
// всё это живёт на экране заказов, куда карточка и ведёт.
//
// Презентационный компонент без стора: одну и ту же карточку рисует значок
// текущих заказов в шапке (HeaderOrders) и любой другой список.
export function ActiveOrderCard({ order, href, onClick }) {
  const o = order || {};
  const mod = statusMod(o);
  const addr = orderAddressLine(o);
  const when = deliveryWhen(o);

  return (
    <a className="ng-active-order" href={href} onClick={onClick}>
      <div className="ng-active-order__top">
        {o.order_num ? <span className="ng-active-order__num">№ {o.order_num}</span> : null}
        <span className={'ng-order__status' + (mod ? ' ng-order__status--' + mod : '')}>
          {o.status}
        </span>
      </div>
      {addr ? <div className="ng-active-order__addr">{addr}</div> : null}
      {when ? <div className="ng-active-order__when">{when}</div> : null}
    </a>
  );
}

// Список компактных карточек. Пустой список — ничего не рисуем.
// hrefFor(order) — куда ведёт карточка: у шапки это полный путь на страницу
// заказа, внутри ЛК хватило бы одного хэша.
export function ActiveOrderList({ orders, hrefFor, onCardClick }) {
  const list = orders || [];
  if (!list.length) return null;

  return (
    <div className="ng-active-orders">
      {list.map((o) => (
        <ActiveOrderCard key={o.id} order={o} href={hrefFor ? hrefFor(o) : null} onClick={onCardClick} />
      ))}
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/ActiveOrders.jsx